import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useUser } from "@/contexts/user-provider";
import { getCurrentProviderNotificationCounts } from "@/api/dosespot/notification-counts";
import { useUnreadNotificationCount } from "@/query/notifications/notifications";

/**
 * Hook to fetch DoseSpot notification counts for the current provider.
 * Only fires when the provider has a DoseSpot user ID.
 */
export function useDosespotNotificationCounts() {
  const $ = _c(5);
  const {
    currentUser
  } = useUser();
  const t0 = currentUser?.id;
  let t1;
  if ($[0] !== t0) {
    t1 = ["dosespot-notification-counts", t0];
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!currentUser?.dosespotUserId;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      queryKey: t1,
      queryFn: getCurrentProviderNotificationCounts,
      enabled: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return useQuery(t3);
}

/**
 * Combined notification count: in-app unread notifications + DoseSpot pending.
 * Used for the sidebar badge so it reflects both sources.
 */
export function useCombinedNotificationCount() {
  const unreadCount = useUnreadNotificationCount();
  const {
    data: dosespotCounts
  } = useDosespotNotificationCounts();
  const dosespotPending = dosespotCounts?.totalPending ?? 0;
  return unreadCount + dosespotPending;
}